import { useContext, useState } from 'react';
import { Ribbon } from '@bitrise/bitkit';
import { manageExceededLimitsPagePath } from '@/utils/monolithApiRouteService';
import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';

const PlanDowngradeBanner = () => {
  const { account } = useContext(GlobalPropsContext);

  const isOwner = account?.isOwner;

  const { mutate } = useMutateUserMetadata({ transform: false });

  const [isClosed, setIsClosed] = useState(false);

  if (!account || isClosed) {
    return null;
  }

  const onRibbonClose = () => {
    mutate({ [`scheduled_downgrade_banner_notification_on_${account.slug}`]: false });
    setIsClosed(true);
  };

  const action = isOwner
    ? { href: manageExceededLimitsPagePath(account.slug), label: 'Manage exceeded limits' }
    : undefined;

  return (
    <Ribbon colorScheme="yellow" onClose={onRibbonClose} action={action}>
      <p>
        <strong>Your plan change will be effective in 5 days.</strong> By switching to the new plan, you will exceed
        some of its limits.
      </p>
    </Ribbon>
  );
};

export default PlanDowngradeBanner;
